import React from "react";
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";

const ConfirmationDialog = ({ open, onClose, title, onConfirm, onCancel }) => {
  const handleConfirm = () => {
    onConfirm(); // Llama a la función de devolución de llamada para el botón "SI"
    onClose();
  };

  const handleCancel = () => {
    onCancel(); // Llama a la función de devolución de llamada para el botón "NO"
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button
          variant="contained"
          color="success"
          onClick={handleConfirm}
          sx={{ width: "100%", mr: 1 }}
        >
          SI
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleCancel}
          sx={{ width: "100%", mr: 1 }}
        >
          NO
        </Button>
        {/* <Fab color="primary" aria-label="Si" onClick={handleConfirm}>
          SI
        </Fab>
        <Fab color="secondary" aria-label="No" onClick={handleCancel}>
          NO
        </Fab> */}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
